import InmobiliariasTemplate from "../components/templates/InmobiliariasTemplate";

const Inmobiliarias = () => {
    return <InmobiliariasTemplate/>;
};

export default Inmobiliarias;